
export class JsonFile {
    static emailsReceived = 'emailsReceived.json';
}

export const endOfFileContent = `

&nbsp;

&nbsp;

`;